import "./AdminSection.css"

export default function AdminSection({ etapa, titulo, contexto = undefined, disabled=false, displayNone=false, children, acoes = undefined }) {
    return <>
        <div className={`admin-section ${displayNone ? 'display-none' : ''}`}>
            <div className={`${disabled ? 'disabled' : ''}`}>
                <div className="admin-section-header">
                    <div className="admin-section-header-text">
                        <div className="admin-section-header-title">
                            <span>{etapa}</span>
                            <h1>{titulo}</h1>
                        </div>
                        <span className="admin-section-header-context">{contexto}</span>
                    </div>
                    {typeof botoes !== undefined && (
                        <div className="admin-section-header-actions">
                            {acoes}
                        </div>
                    )}
                </div>
                <div className="admin-section-body">
                    {children}
                </div>
            </div>
        </div>
    </>
}